<script>
import Footer from "../components/Footer.svelte";
import Header from "../components/header/Header.svelte";
import Modals from "../components/Modals.svelte";
import Topbar from "../components/Topbar.svelte";
import Card from "../components/contact/Card.svelte";
import Person from "../components/contact/Person.svelte";
</script>

<Topbar />
<div class="container" id="wrapper">
  <Header />

  <div class="row">
    <div class="col-xs-12">
      <div id="content" class="main-content">
        <h1>Kontakt</h1>
        <div class="contact-card-container">
          <Card
            image="assets/order.png"
            showIcon="{false}"
            heading="Order & kundservice"
            content="<p>Är din säljare upptagen svarar första lediga på detta nummer.</p>"
            phone="010-483 40 00"
            email="order@gothes.se"
          />

          <Card
            image="assets/falun.png"
            heading="Falun"
            content="<p>Box 1928<br>SE-791 19 Falun</p><p>Roxnäsvägen 14<br>SE-791 44 Falun</p>"
            phone="010-483 40 00"
            fax="010-483 40 20"
            map="https://goo.gl/maps/G8iRCgK3XWH3aSLn7"
          />

          <Card
            image="assets/frolunda.png"
            heading="Västra Frölunda"
            content="<p>Britta Sahlgrens gata 1<br>SE-421 31 Västra Frölunda</p>"
            phone="010-483 40 00"
            map="https://goo.gl/maps/Uy9bV2WzujU6PNii8"
          />

          <Card
            image="assets/stockholm.png"
            heading="Stockholm"
            content="<p>Elektravägen 31<br>SE-126 30 Hägersten</p>"
            phone="010-483 40 00"
            map="https://goo.gl/maps/Xs4G4PNNe2nBsNnk7"
          />

          <Card
            image="assets/malmo.png"
            heading="Malmö"
            content="<p>Kosterögatan 9<br>SE-211 24 Malmö</p>"
            phone="010-483 40 00"
            map="https://goo.gl/maps/SjskMqUV2a5MYykP9"
          />

          <Card
            image="assets/huskvarna.png"
            heading="Huskvarna"
            content="<p>Esbjörnarp 10<br>SE-561 92 Huskvarna</p>"
            phone="010-483 40 00"
            map="https://goo.gl/maps/ZQeQeN5SqgZaAqQB8"
          />
        </div>

        <h2 class="mb-lg mt-lg">Medarbetare</h2>
        <h3 class="mb-md">Beslag & kundservice</h3>
        <div class="row">
          <Person
            image="assets/anders_bjorklund.jpg"
            city="Falun"
            name="Anders Björklund"
            title="Teknisk support & Order, Lås & Beslag OEM"
            phone="010-483 40 09"
            phone2=""
            email="anders.bjorklund@gothes.se"
          />

          <Person
            image="assets/mats_gustavsson.jpg"
            city="Falun"
            name="Mats Gustavsson"
            title="Teknisk support & Order, Lås & Beslag OEM"
            phone="010-483 40 10"
            phone2=""
            email="mats.gustavsson@gothes.se"
          />

          <Person
            image="assets/nils_danielsson.jpg"
            city="Falun"
            name="Nils Danielsson"
            title="Teknisk support & Order, Lås & Beslag OEM"
            phone="010-483 40 11"
            phone2=""
            email="nils.danielsson@gothes.se"
          />

          <Person
            image="assets/magnus_stromer.jpg"
            city="Falun"
            name="Magnus Strömer"
            title="Teknisk support, Kundservice & Order"
            phone="010-483 40 82"
            phone2=""
            email="magnus.stromer@gothes.se"
          />

          <Person
            image="assets/gustaf_wesslen.jpg"
            city="Falun"
            name="Gustaf Wesslén"
            title="Teknisk support & Order, Lås & Beslag OEM"
            phone="010-483 40 14"
            phone2=""
            email="gustaf.wesslen@gothes.se"
          />

          <Person
            image="assets/daniel_elvefors.jpg"
            city="Falun"
            name="Daniel Elvefors"
            title="Teknisk support & Order, Lås & Beslag OEM"
            phone="010-483 40 22"
            phone2=""
            email="daniel.elvefors@gothes.se"
          />

          <h3 class="col-md-12 section-title">Utesälj OEM</h3>

          <Person
            image="assets/per_yman.jpg"
            city="Stockholm"
            name="Per Yman"
            title="Försäljningsansvarig  OEM – Sverige"
            phone="010-483 40 36"
            phone2="070-313 48 02"
            email="per.yman@gothes.se"
          />

          <Person
            image="assets/thomas_larson.jpg"
            city="Göteborg"
            name="Thomas Larson"
            title="Regionansvarig Säljare,
          OEM Trä – Götaland"
            phone="010-483 40 27"
            phone2="070-983 99 89"
            email="thomas.larson@gothes.se"
          />

          <Person
            image="assets/sebastian_harnesk.jpg"
            city="Malmö"
            name="Sebastian Harnesk"
            title="Regionansvarig Säljare,
          OEM Metall – Götaland"
            phone="010-483 40 49"
            phone2="070-313 48 17"
            email="sebastian.harnesk@gothes.se"
          />

          <Person
            image="assets/fredrik_oblom.jpg"
            city="Huskvarna"
            name="Fredrik Öblom"
            title="Regionansvarig Säljare,
          OEM Trä– Götaland"
            phone="010-483 40 48"
            phone2="070-313 48 06"
            email="fredrik.oblom@gothes.se"
          />

          <Person
            image="assets/markus_orr.jpg"
            city="Falun"
            name="Markus Orr"
            title="Regionansvarig Säljare OEM Metall & Trä – Svealand/Norrland"
            phone="010-483 40 13"
            phone2="070-313 48 90"
            email="markus.orr@gothes.se"
          />
          <h3 class="col-md-12 section-title">Inköp & Beslag</h3>
          <Person
            image="assets/bo_lofgren.jpg"
            city="Falun"
            name="Bo Löfgren"
            title="Inköps- & Avtalsansvarig"
            phone="010-483 40 12"
            phone2="070-313 48 09"
            email="bo.lofgren@gothes.se"
          />

          <Person
            image="assets/helena_andersson.jpg"
            city="Falun"
            name="Heléna Andersson"
            title="Inköp"
            phone="010-483 40 06"
            phone2=""
            email="helena.andersson@gothes.se"
          />

          <Person
            image="assets/jan_ostlund.jpg"
            city="Falun"
            name="Jan Östlund"
            title="Material Administrationsansvarig"
            phone="010-483 40 24"
            phone2="070-313 48 10"
            email="jan.ostlund@gothes.se"
          />
          <h3 class="col-md-12 section-title">Administration</h3>
          <Person
            image="assets/hakan_ostlund.jpg"
            city="Falun"
            name="Håkan Östlund"
            title="VD"
            phone="010-483 40 07"
            phone2="070-313 48 00"
            email="hakan.ostlund@gothes.se"
          />

          <Person
            image="assets/kristina_ostlund.jpg"
            city="Falun"
            name="Kristina Östlund"
            title="Ekonomi- & Personalansvarig"
            phone="010-483 40 47"
            phone2="070-313 48 18"
            email="kristina.ostlund@gothes.se"
          />

          <Person
            image="assets/patrik_ostlund.jpg"
            city="Göteborg"
            name="Patrik Östlund"
            title="Marknadsföring & Kommunikation"
            phone="010-483 40 44"
            phone2="070-313 48 20"
            email="patrik.ostlund@gothes.se"
          />

          <Person
            image="assets/henrik_ostlund.jpg"
            city="Falun"
            name="Henrik Östlund"
            title="Affärskoordinator"
            phone="010-483 40 19"
            phone2="070-548 13 00"
            email="henrik.ostlund@gothes.se"
          />

          <Person
            image="assets/giovanna_ostlund.jpg"
            city="Göteborg"
            name="Giovanna Östlund"
            title="Visual Marketing & Social Media"
            phone="010-483 40 43"
            phone2="070-313 48 04"
            email="giovanna.ostlund@gothes.se"
          />

          <Person
            image="assets/lene_swordson.jpg"
            city="Falun"
            name="Lene Swordson"
            title="Redovisningsekonom"
            phone="010-483 40 01"
            phone2=""
            email="lene.swordson@gothes.se"
          />

          <Person
            image="assets/fredrica_hjort.jpg"
            city="Falun"
            name="Fredrica Hjort"
            title="Redovisningsekonom"
            phone="010-483 40 17"
            phone2=""
            email="fredrica.hjort@gothes.se"
          />

          <Person
            image="assets/niclas_groth.jpg"
            city="Falun"
            name="Niclas Groth"
            title="IT-, Affärssystem-, Kvalitet- & Miljöansvarig"
            phone="010-483 40 08"
            phone2="070-313 48 08"
            email="niclas.groth@gothes.se"
          />

          <Person
            image="assets/simon_thunstedt.jpg"
            city="Falun"
            name="Simon Thunstedt"
            title="Affärssytemutvecklare & Reklamationsansvarig"
            phone="010-483 40 38"
            phone2=""
            email="simon.thunstedt@gothes.se"
          />

          <Person
            image="assets/kundservice.jpg"
            city=""
            name="Order & Kundservice"
            title="Är din säljare upptagen svarar första lediga på detta nummer"
            phone="010-483 40 25"
            phone2=""
            email="order@gothes.se"
          />
          <h3 class="col-md-12 section-title">Logistik</h3>
          <Person
            image="assets/josef_strandin.jpg"
            city="Falun"
            name="Josef Strandin"
            title="Logistikansvarig"
            phone="010-483 40 26"
            phone2="070-313 48 05"
            email="josef.strandin@gothes.se"
          />

          <Person
            image="assets/stefan_eriksson.jpg"
            city="Falun"
            name="Stefan Eriksson"
            title="Logistikförman & Arbetsledare"
            phone="010-483 40 28"
            phone2=""
            email="stefan.eriksson@gothes.se"
          />

          <Person
            image="assets/peter_sandgren.jpg"
            city="Falun"
            name="Peter Sandgren"
            title="Logistiktekniker"
            phone="010-483 40 30"
            phone2=""
            email="peter.sandgren@gothes.se"
          />

          <Person
            image="assets/tomas_forslund.jpg"
            city="Falun"
            name="Tomas Forslund"
            title="Logistiktekniker"
            phone="010-483 40 31"
            phone2=""
            email="tomas.forslund@gothes.se"
          />

          <Person
            image="assets/thomas_j_s.jpg"
            city="Falun"
            name="Thomas Johansson Stenberg"
            title="Logistiktekniker"
            phone="010-483 40 33"
            phone2=""
            email="thomas.johansson.stenberg@gothes.se"
          />

          <Person
            image="assets/fredrik_johansson.jpg"
            city="Falun"
            name="Fredrik Johansson"
            title="Logistiktekniker"
            phone="010-483 40 29"
            phone2=""
            email="fredrik.johansson@gothes.se"
          />

          <Person
            image="assets/gabriel_svardstrom.jpg"
            city="Falun"
            name="Gabriel Svärdström"
            title="Logistiktekniker"
            phone="010-483 40 23"
            phone2=""
            email="gabriel.svardstrom@gothes.se"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<Footer />
<Modals />
